import React from 'react';

import { getFormattedTimeWindow, LayoutType, Tooltip } from '@bringg/react-components';

import { getHoursFormat } from '../../../../../utils/date-utils';

interface Props {
	startTime?: string;
	endTime?: string;
	hourFormat: string;
	timeZone: string;
	timeName?: string;
}

const TimeColumn = ({ startTime, endTime, hourFormat, timeZone, timeName }: Props) => {
	const classNames = timeName ? timeName : 'time-window';
	const emptyTime = '—:—';
	return startTime ? (
		<Tooltip title={getFormattedTimeWindow(startTime, endTime, hourFormat, timeZone, LayoutType.HORIZONTAL)}>
			<div data-test-id={classNames}>
				<span className={`${classNames}-first-date`} data-test-id={`${classNames}-first-date`}>
					{startTime ? getHoursFormat(startTime, timeZone, hourFormat) : emptyTime}
				</span>
				<span className={`formatted-${classNames}-hyphen`}> - </span>
				<span className={`${classNames}-second-date`} data-test-id={`${classNames}-second-date`}>
					{endTime ? getHoursFormat(endTime, timeZone, hourFormat) : emptyTime}
				</span>
			</div>
		</Tooltip>
	) : null;
};

export default TimeColumn;
